import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  // Check for existing authentication on mount
  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = () => {
    try {
      const authData = localStorage.getItem('summaryAuth');
      if (authData) {
        const { timestamp, authenticated } = JSON.parse(authData);
        const now = Date.now();
        const oneHour = 60 * 60 * 1000; // 1 hour in milliseconds
        
        // Check if authentication is still valid (within 1 hour)
        if (authenticated && (now - timestamp) < oneHour) {
          setIsAuthenticated(true);
        } else {
          // Authentication expired, clear it
          localStorage.removeItem('summaryAuth');
          setIsAuthenticated(false);
        }
      }
    } catch (error) {
      console.error('Error checking auth status:', error);
      localStorage.removeItem('summaryAuth');
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  const login = (password) => {
    // Get password from environment variable or use default
    const correctPassword = process.env.REACT_APP_SUMMARY_PASSWORD || 'admin123';
    
    if (password === correctPassword) {
      const authData = {
        authenticated: true,
        timestamp: Date.now()
      };
      localStorage.setItem('summaryAuth', JSON.stringify(authData));
      setIsAuthenticated(true);
      return true;
    }
    return false;
  };

  const logout = () => {
    localStorage.removeItem('summaryAuth');
    setIsAuthenticated(false);
  };

  const value = {
    isAuthenticated,
    loading,
    login,
    logout,
    checkAuthStatus
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
